import { AuthSession } from '@core/models/auth/auth-session';
import {
    AUTH_DELETE,
    AUTH_COMPANY_SET,
    AUTH_USER_SET
  } from '../action-types';
  import { IAuthState, initialAuthState } from './auth-state';
import { AuthTokenType } from '@core/models/auth/auth-token-type';
import { AccountType } from '@core/models/account/account-type';
  
export function reducer(state: IAuthState = initialAuthState(), action: any): IAuthState {        
      
    switch (action.type) {
        
        case AUTH_USER_SET:
            return {
                ...state,
                user: action.payload
            };

        case AUTH_COMPANY_SET:
            return {
                ...state,
                company: action.payload
            };
            
        case AUTH_DELETE:
            return {
                ...state,
                company: {
                    access_token: '',
                    refresh_token: '',
                    token_type: AuthTokenType.BEARER,
                    expires_in: 0,
                    _profile_type: AccountType.COMPANY,
                    _profile_id: '',
                },
                user: {
                    access_token: '',
                    refresh_token: '',
                    token_type: AuthTokenType.BEARER,
                    expires_in: 0,
                    _profile_type: AccountType.USER,
                    _profile_id: '',
                }
            };

        default:
            return state;
    }
  }